export default __webpack_public_path__ + "static/media/instructor-8.1f3e2a39.jpg";